const oneHourInSeconds = 3600;
const oneDayInHours = 24;
const daysBeforeExpiration = 7;
const _maxAge = parseInt(process.env.REACT_APP_AUTH0_AUTH_MAXAGE!);

export const auth0MaxAge = !isNaN(_maxAge)
  ? _maxAge
  : oneHourInSeconds * (oneDayInHours * daysBeforeExpiration);

export const auth0ExpirationDate = new Date(Date.now() + auth0MaxAge * 1000);
